import React from 'react';

import dayjs from 'shared/helpers/dayjs';
import DateNavHeader from 'events/components/DateNavHeader/DateNavHeader';

import * as Styled from 'events/styles/EventsHomePage.style';
import * as Text from 'theme/components/Text.style';

interface EventsHomeLeftColumnProps {
  isDesktopView: boolean;
  selectedDate: dayjs.Dayjs;
  onSelectDate: (date: Date) => void;
  searchCalendarPill: React.ReactNode;
  summarySection: React.ReactNode;
  prioritiesSection: React.ReactNode;
  activitySection: React.ReactNode;
  scrollRef?: React.RefObject<HTMLDivElement>;
}

export default function EventsHomeLeftColumn({
  isDesktopView,
  selectedDate,
  onSelectDate,
  searchCalendarPill,
  summarySection,
  prioritiesSection,
  activitySection,
  scrollRef,
}: EventsHomeLeftColumnProps): JSX.Element {
  return (
    <Styled.LeftColumn ref={scrollRef}>
      {isDesktopView ? (
        <Styled.SidebarHeader>
          <DateNavHeader
            selectedDate={selectedDate.toDate()}
            onSelectDate={onSelectDate}
          />
          {searchCalendarPill}
        </Styled.SidebarHeader>
      ) : (
        <Styled.MobileDateNav>
          <DateNavHeader
            selectedDate={selectedDate.toDate()}
            onSelectDate={onSelectDate}
          />
          <Styled.MobileDateTitleSection>
            <Text.H3>{selectedDate.format('ddd, MMM D')}</Text.H3>
          </Styled.MobileDateTitleSection>
        </Styled.MobileDateNav>
      )}
      <Styled.SidebarContent>
        <Styled.SummaryPrioritiesGroup>
          {summarySection}
          {prioritiesSection}
        </Styled.SummaryPrioritiesGroup>
        {activitySection}
      </Styled.SidebarContent>
    </Styled.LeftColumn>
  );
}
